import Dropzone from "react-dropzone";
import styled from "styled-components";
import { useState, forwardRef, useImperativeHandle } from "react";
import { Alert } from "@mui/material";

const WrapperAlert = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  @keyframes showAlert {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;
const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

const UploadImage = forwardRef(
  ({ children, style, callBackFile, sizeFile, textAlert, closeAlert }, ref) => {
    const [showAlert, setShowAlert] = useState(false);
    let dropzoneOpen = null;

    // Expose open method to parent component
    useImperativeHandle(ref, () => ({
      open: () => {
        // inputRef.current?.click();
        dropzoneOpen?.();
      },
    }));

    const onDrop = (acceptedFiles) => {
      if (!acceptedFiles.length) {
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 2500);
        return;
      }

      const file = acceptedFiles[0];
      const reader = new FileReader();

      const fileUpload = Object.assign(file, {
        fileData: URL.createObjectURL(file),
      });

      reader.onload = (e) => {
        callBackFile(fileUpload, e.target.result);
      };

      reader.readAsDataURL(file);
    };

    return (
      <>
        <Dropzone
          onDrop={(acceptedFiles) => onDrop(acceptedFiles)}
          accept={[".jpeg", ".png", ".jpg"]}
          maxSize={4194304}
          // minSize={0}
        >
          {({ getRootProps, getInputProps, open }) => {
            dropzoneOpen = open;
            return (
              <section style={{ width: "100%", ...style }}>
                <div {...getRootProps()} onClick={open}>
                  <input {...getInputProps()} />
                  <div>{children}</div>
                </div>
              </section>
            );
          }}
        </Dropzone>

        {showAlert && (
          <WrapperAlert>
            <DivAlert>
              <Alert
                className="MuiPaper-root-MuiAlert-root"
                severity={"warning"}
              >
                {"The file size is larger than 4 MB."}
              </Alert>
            </DivAlert>
          </WrapperAlert>
        )}
      </>
    );
  },
);

export default UploadImage;
